import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminPage } from './pages/AdminPage';
import { DeniedPage } from './pages/DeniedPage';
import { HomePage } from './pages/HomePage';
import { MatDisplayPage } from './pages/MatDisplayPage';
import { PeoplePage } from './pages/PeoplePage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/denied" element={<DeniedPage />} />
        <Route path="/admin/people" element={<PeoplePage />} />
        <Route path="/t/:slug/mat/:number" element={<MatDisplayPage />} />
      </Routes>
    </BrowserRouter>
  );
}
